import { useQuery } from 'data-fetching-client';
import { GET_ACTIVE_TRIALS } from 'pricing-pages-api/trials/queries';
import { apiNameToTrialIds } from 'self-service-api/constants/Trials';
import { useIsInAppAuth } from '../user/useUserInfo';
const getTrialId = apiName => {
  return apiNameToTrialIds[apiName];
};
const useActiveTrials = ({
  skip
} = {}) => {
  const isAppAuth = useIsInAppAuth();
  return useQuery(GET_ACTIVE_TRIALS, {
    skip: skip || !isAppAuth
  });
};
export const useCurrentTrial = apiName => {
  const trialId = getTrialId(apiName);
  const {
    data
  } = useActiveTrials({
    skip: trialId === undefined
  });
  return data === null || data === void 0 ? void 0 : data.activeTrials.find(activeTrial => {
    return activeTrial.trial.id === trialId;
  });
};